module.exports = __webpack_public_path__ + "static/media/1.324d81ea.png";